<ng-template #bookableFields let-content="content">
  <mat-form-field><input [(ngModel)]="content.bookingUrl" matInput placeholder="{{'dynamicContent.bookingUrl' | translate}}">
  </mat-form-field>
  <mat-form-field *ngIf="type !== 'screensaver'">
    <input [(ngModel)]="content.bookingText" matInput placeholder="{{'dynamicContent.bookingText' | translate}}"/>
  </mat-form-field>
  <mat-form-field *ngIf="type !== 'screensaver'">
    <input [(ngModel)]="content.bookingTextScreen" matInput placeholder="{{'dynamicContent.bookingTextScreen' | translate}}"/>
  </mat-form-field>
</ng-template>
<ng-template #bookableContent let-lang="lang">
  <h2>{{ 'dynamicContent.externalLinks' | translate }}</h2>
  <div class="booking" *ngIf="dynamicContent.lang === lang">
    <ng-container *ngTemplateOutlet="bookableFields; context:{ content: dynamicContent.content }"></ng-container>
  </div>
  <div class="booking" *ngIf="dynamicContent.lang !== lang">
    <ng-container *ngTemplateOutlet="bookableFields; context:{ content: translationEntries[lang].content }"></ng-container>
  </div>
</ng-template>

<page-toolbar *ngIf="!isLoading" [pageActions]="pageActions"
                  title="{{type !== 'category' ? parents.join(' > ') : ('dynamicContent.categories' | translate)}} > {{getTitle() | translate}}"></page-toolbar>

<mat-card appearance="outlined" *ngIf="!isLoading && (!dynamicContent || pageError)" class="">
  <h2>{{ 'general.no-data'|translate }}</h2>
  <mat-card-content *ngIf="pageError">
    <p>Error: {{ pageError }}</p>
  </mat-card-content>
</mat-card>

<div *ngIf="!isLoading && !!dynamicContent && !pageError" class="main-container">
  <div class="add-translation-button" *ngIf="availableLanguages?.length !== languages?.length && !this.create && availableLanguages?.length > 1">
    <button (click)="changeLanguage()" class="ibexfusion-raised-button small" mat-button>{{ 'dynamicContent.addTranslation' | translate }}
    </button>
  </div>
  <mat-tab-group (selectedTabChange)="tabChanged($event)" [selectedIndex]="selectedIndex"
                 [ngClass]="{ 'no-translations': availableLanguages?.length <= 1 }">
    <mat-tab *ngFor="let lang of languages;" label="{{lang}}">
      <ng-template mat-tab-label>
        <div class="custom-tab-label">
          <img [src]="'../../../../assets/img/languages/' + lang + '.jpg'" class="main-language"/>
          <mat-icon (click)="removeLanguage(lang, $event)" *ngIf="lang !== masterLanguage">delete</mat-icon>
        </div>
      </ng-template>
      <ng-container *ngIf="!['category'].includes(type)">
        <ng-container *ngIf="!['person', 'voting', 'webcam', 'quiz', 'feedback', 'gastronomy'].includes(type)">
          <mat-card appearance="outlined" *ngIf="!!dynamicContent && dynamicContent.content">
            <div class="title-container">
              <div class="title-field">
                <mat-form-field>
                  <mat-label>{{'general.title' | translate}}</mat-label>
                  <input *ngIf="dynamicContent.lang === lang" [(ngModel)]="dynamicContent.title" matInput
                         required #titleInput>
                  <input *ngIf="dynamicContent.lang !== lang" [(ngModel)]="translationEntries[lang].title" matInput
                          required #titleInput>
                </mat-form-field>
                <div *ngIf="dynamicContent.lang !== lang" class="disclaimer">{{'general.deeplDisclaimer' | translate}}</div>
                <mat-icon [matTooltip]="'dynamicContent.translateFromMain' | translate" *ngIf="dynamicContent.lang !== lang"
                          (click)="translateTitleFromMainLanguage(lang)">translate
                </mat-icon>
              </div>
              <mat-form-field *ngIf="categories?.length">
                <mat-select [(ngModel)]="dynamicContent.content.categories" multiple
                            placeholder="{{'dynamicContent.categories' | translate}}">
                  <mat-option *ngFor="let category of categories" [value]="category._id">{{ category.title }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div *ngIf="type === 'information' && dynamicContent.isNavigationOnly !== true" class="iframe-container top-container">
              <ibex-checkbox (click)="updateIframeContent($event); checkContent();" [checked]="!!dynamicContent.content.iframe"
                             [title]="'dynamicContent.useIframe' | translate" #iframe></ibex-checkbox>
              <mat-form-field *ngIf="iframeVisible">
                <ng-container *ngIf="dynamicContent.lang === lang">
                  <input [(ngModel)]="dynamicContent.content.iframe" matInput placeholder="Url" type="url">
                </ng-container>
                <ng-container *ngIf="dynamicContent.lang !== lang">
                  <input [(ngModel)]="translationEntries[lang].content.iframe" matInput placeholder="Url" type="url">
                </ng-container>
              </mat-form-field>
            </div>
            <div *ngIf="type === 'opening-hours' && dynamicContent.lang === lang" class="top-container">
              <ibex-checkbox [checked]="dynamicContent.content.showInWidget" [title]="'dynamicContent.openHours.showInWidget' | translate"
                             (click)="dynamicContent.content.showInWidget = $event.val"></ibex-checkbox>
            </div>
            <div *ngIf="type === 'alphabet' && dynamicContent.lang === lang" class="alphabet-container top-container">
              <ibex-checkbox [checked]="dynamicContent.content.goodToKnow" [title]="'dynamicContent.goodToKnow' | translate"
                             (click)="dynamicContent.content.goodToKnow = $event.val"></ibex-checkbox>
            </div>
            <div *ngIf="type === 'ticker' && dynamicContent.lang === lang && !ibexsmartOnly" class="color-field">
              <div class="color-field-container">
                <ibex-checkbox #colorOverwrite [checked]="!!dynamicContent?.content?.color" (change)="dynamicContent.content.color=null"
                               [title]="'dynamicContent.tickerColorOverwrite' | translate"></ibex-checkbox>
                <smart-input *ngIf="colorOverwrite.checked" [(model)]="dynamicContent.content" translationPrefix="dynamicContent"
                             key="color" [hideDescription]="true"></smart-input>
              </div>
              <div class="color-field-container">
                <ibex-checkbox #backgroundOverride [checked]="!!dynamicContent?.content?.backgroundColor"
                               (change)="dynamicContent.content.backgroundColor=null"
                               [title]="'dynamicContent.tickerBackgroundColorOverwrite' | translate"></ibex-checkbox>
                <smart-input *ngIf="backgroundOverride.checked" [(model)]="dynamicContent.content" translationPrefix="dynamicContent"
                             key="backgroundColor" [hideDescription]="true"></smart-input>
              </div>
            </div>
            <div *ngIf="type === 'screensaver' && dynamicContent.lang === lang" class="screensaver-container top-container">
              <ibex-checkbox (click)="dynamicContent.content.isScreensaver = $event.val" [checked]="dynamicContent.content.isScreensaver"
                *ngIf="!appConfig?.hideScreensaver && (!!appConfig?.displaySlideShowWidget || !!appConfig?.displayBackgroundSlides)"
                [title]="'dynamicContent.isScreensaver' | translate"></ibex-checkbox>
              <ibex-checkbox *ngIf="!!appConfig?.displaySlideShowWidget" [title]="'dynamicContent.isSlideShow' | translate"
                             (click)="dynamicContent.content.isSlideShow = $event.val"
                             [checked]="dynamicContent.content.isSlideShow"></ibex-checkbox>
              <ibex-checkbox *ngIf="!!appConfig?.displayBackgroundSlides" [title]="'dynamicContent.isNavigationSlideshow' | translate"
                             (click)="dynamicContent.content.isNavigationSlideshow = $event.val"
                             [checked]="dynamicContent.content.isNavigationSlideshow"></ibex-checkbox>
            </div>
            <div *ngIf="type === 'social-media' && dynamicContent.lang === lang" class="social-media-container top-container">
              <smart-input [(model)]="dynamicContent" [hideDescription]="true" jsonPointerKey="/content" key="platform"
                           translationPrefix="dynamicContent.socialMedia"></smart-input>
              <smart-input [(model)]="dynamicContent" [hideDescription]="true" jsonPointerKey="/content" key="link"
                           translationPrefix="dynamicContent.socialMedia"></smart-input>
            </div>

            <ng-container *ngIf="!dynamicContent.content.iframe">
              <div *ngIf="dynamicContent && !['screensaver', 'public-transport'].includes(type) && appConfig?.overwriteContentType !== 'memory'">
                <div class="editor-header"><h3>{{ 'dynamicContent.content' | translate }}</h3></div>
                <editor (changeContent)="onEditorChange($event, 'textContent')" [content]="dynamicContent.content.textContent"
                                  *ngIf="dynamicContent.lang === lang && !dynamicContent.disableMasterLanguage"
                                  [height]="['important-numbers', 'activity', 'social-media'].includes(type) ? '150px' : '300px'"></editor>

                <editor (changeContent)="onEditorChange($event, 'textContent', lang)" [language]="lang" [packageId]="packageId"
                                  *ngIf="dynamicContent.lang !== lang && translationEntries[lang].content && selectedLanguage === lang"
                                  [content]="translationEntries[lang].content.textContent" [mainLanguageContent]="dynamicContent.content.textContent"
                                  [height]="['important-numbers', 'activity', 'social-media'].includes(type) ? '150px' : '300px'"></editor>
                <div *ngIf="type === 'breaking-news' || (appConfig?.overwriteContentType === 'news' && appConfig?.showDate)" class="date-field">
                  <mat-form-field>
                    <input [(ngModel)]="dynamicContent.content.date" [matDatepicker]="startPicker" matInput
                           placeholder="{{'dynamicContent.date' | translate}}">
                    <mat-datepicker-toggle [for]="startPicker" matPrefix></mat-datepicker-toggle>
                    <mat-datepicker #startPicker></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
            </ng-container>
            <div *ngIf="type === 'public-transport'" class="public-transport">
              <div class="search">
                <mat-form-field>
                  <input #state="ngModel" (ngModelChange)="searchStop()" [(ngModel)]="currentSearchTerm" [matAutocomplete]="tdAuto" matInput
                         name="state" placeholder="Haltestelle suchen">
                </mat-form-field>
                <mat-autocomplete #tdAuto="matAutocomplete" (optionSelected)="selectStop($event)">
                  <mat-option *ngFor="let stop of stops" [value]="stop.stopId"><span>{{stop.name}}</span></mat-option>
                </mat-autocomplete>

                <icon-selector [(model)]="dynamicContent.content" type="new" variant="blank" key="stopIcon"></icon-selector>
              </div>
              <div class="content">
                <mat-form-field appearance="fill">
                  <mat-label>Haltestellen ID</mat-label>
                  <input matInput type="number" [(ngModel)]="dynamicContent.content.stopId" [disabled]="true"/>
                </mat-form-field>

                <mat-form-field appearance="fill">
                  <mat-label>Haltestellen Name</mat-label>
                  <input matInput [(ngModel)]="dynamicContent.content.stopName" [disabled]="true"/>
                </mat-form-field>

                <button class="ibexfusion-icon-button" mat-icon-button (click)="dynamicContent.content.stopId = null;  dynamicContent.content.stopName = null">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>

              <div class="additional-stops">
                <div class="title">Zusätzliche Haltestellen</div>
                <div class="main-actions">
                  <button (click)="addStop()" class="ibexfusion-raised-button small" mat-button>Haltestelle hinzufügen</button>
                </div>
                <div class="no-stops" *ngIf="!dynamicContent?.content?.additionalStops?.length">Noch keine Haltestellen hinzugefügt</div>
                <div class="stop" *ngFor="let stop of dynamicContent.content.additionalStops; let i = index">
                  <mat-form-field>
                    <input #state="ngModel" (ngModelChange)="searchStop(i)" [(ngModel)]="searchTerms[i]" [matAutocomplete]="tdAuto" matInput
                           name="state" placeholder="Haltestelle suchen">
                  </mat-form-field>
                  <mat-autocomplete #tdAuto="matAutocomplete" (optionSelected)="selectStop($event, i)">
                    <mat-option *ngFor="let stop of stops" [value]="stop.stopId"><span>{{stop.name}}</span></mat-option>
                  </mat-autocomplete>

                  <mat-form-field appearance="fill">
                    <mat-label>Haltestellen ID</mat-label>
                    <input matInput type="number" [(ngModel)]="stop.stopId" [disabled]="true"/>
                  </mat-form-field>

                  <mat-form-field appearance="fill">
                    <mat-label>Haltestellen Name</mat-label>
                    <input matInput [(ngModel)]="stop.stopName" [disabled]="true"/>
                  </mat-form-field>

                  <button class="ibexfusion-icon-button" mat-icon-button (click)="removeStop(i)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </mat-card>
        </ng-container>

        <activity *ngIf="type === 'activity'" [dynamicContent]="dynamicContent" [parent]="parent"></activity>
        <feedback *ngIf="type === 'feedback'" [create]="create" [dynamicContent]="dynamicContent" [parent]="parent"></feedback>
        <gastronomy *ngIf="type === 'gastronomy'" [create]="create" [dynamicContent]="dynamicContent" [parent]="parent"></gastronomy>
        <important-numbers *ngIf="type === 'important-numbers'" [create]="create" [dynamicContent]="dynamicContent"></important-numbers>
        <event-dates *ngIf="['event'].includes(type) && dynamicContent.lang === lang" [dynamicContent]="dynamicContent"></event-dates>
        <opening-hours [dynamicContent]="dynamicContent" [type]="type" [translations]="translationEntries" [activeLanguage]="selectedLanguage"
                       *ngIf="['opening-hours', 'restaurant'].includes(type) && (!!myPackage?.ibexTouch?.enabled || !!myPackage?.ibexApp?.enabled || !!myPackage?.ibexTablet?.enabled) && !appConfig?.noOpeningInfo"></opening-hours>
        <person *ngIf="type === 'person'" [create]="create" [dynamicContent]="dynamicContent" [parent]="parent" [lang]="lang" [translationEntries]="translationEntries"
                [orientation]="packageInstalledApp.detail.orientationData"></person>
        <quiz *ngIf="type === 'quiz'" [create]="create" [dynamicContent]="dynamicContent" [parent]="parent"></quiz>
        <slide-items *ngIf="type === 'screensaver'" [dynamicContent]="dynamicContent" [lang]="lang"
                     [translationEntries]="translationEntries"></slide-items>
        <voting (finish)="save()" *ngIf="type === 'voting'" [create]="create" [dynamicContent]="dynamicContent" [parent]="parent"></voting>
        <webcam *ngIf="type === 'webcam'" [create]="create"
                [dynamicContent]="dynamicContent.lang === lang ? dynamicContent : translationEntries[lang]"
                [parent]="parent" [onlyTitle]="dynamicContent.lang !== lang || dynamicContent.isNavigationOnly"></webcam>
        <ng-container *ngIf="!dynamicContent.content.iframe">
          <code-snippets *ngIf="!!appConfig?.showCodeSnippets" [dynamicContent]="dynamicContent.lang === lang ? dynamicContent : translationEntries[lang]"></code-snippets>
          <media [dynamicContent]="dynamicContent" [parents]="parents[0]" [parentId]="parentId" [isSecured]="packageInstalledApp.isSecured"
                 [availableLanguages]="availableLanguages" [packageLang]="dynamicContent.lang"
                 [imagesOnly]="!!['ticker'].includes(type)" [imageOnly]="(!!['person', 'social-media', 'public-transport'].includes(type) || appConfig?.overwriteContentType === 'news') && !appConfig.multipleImages"
                 *ngIf="dynamicContent.lang === lang && (!['screensaver', 'activity', 'voting', 'important-numbers', 'webcam', 'breaking-news', 'quiz', 'feedback', 'gastronomy'].includes(type) || (type === 'quiz' && !isQuizMain()))"></media>
          <documents [dynamicContent]="dynamicContent" [lang]="lang" [translationEntries]="translationEntries" [parentId]="parentId"
                     [availableLanguages]="availableLanguages" [packageLang]="dynamicContent.lang" [parents]="parents[0]"
                     *ngIf="!['screensaver', 'activity', 'social-media', 'person', 'ticker', 'voting', 'important-numbers', 'webcam', 'breaking-news', 'quiz', 'feedback', 'gastronomy', 'public-transport'].includes(type) && !['memory'].includes(appConfig?.overwriteContentType)"></documents>
          <logo *ngIf="dynamicContent.lang === lang && !!['social-media'].includes(type) && dynamicContent?.content?.platform === 'other'"
                [dynamicContent]="dynamicContent"></logo>

          <ng-container *ngIf="['restaurant', 'event', 'offer', 'opening-hours', 'information', 'voucher'].includes(type)">
            <contact *ngIf="contact && dynamicContent.lang === lang" [contact]="contact" [dynamicContent]="dynamicContent"></contact>

            <mat-card appearance="outlined" class="additional-fields" *ngIf="appConfig?.additionalFields">
              <h2>{{ 'dynamicContent.additionalFields' | translate }}</h2>
              <div class="fields">
                <ng-container *ngFor="let field of appConfig.additionalFields">
                  <mat-form-field *ngIf="field.fieldType === 'STRING'">
                    <input [(ngModel)]="dynamicContent.content[field.fieldName]" matInput placeholder="{{field.fieldTitle}}">
                  </mat-form-field>
                </ng-container>
              </div>
            </mat-card>

            <mat-card appearance="outlined" *ngIf="type === 'offer'" class="offer">
              <div (click)="readMe('dynamic-content-offer-products', 'dynamic-content')" class="button-right-container float-right">
                <button class="ibexfusion-icon-button help" mat-icon-button>
                  <mat-icon>help</mat-icon>
                </button>
              </div>
              <ng-container *ngTemplateOutlet="bookableContent; context:{ lang }"></ng-container>
            </mat-card>
            <mat-card appearance="outlined" *ngIf="type === 'voucher'">
              <mat-card-content>
                <h2>{{ 'dynamicContent.productsTitle' | translate }}</h2>
                <mat-form-field class="expiration-date">
                  <input [(ngModel)]="dynamicContent.content.expirationDate" [matDatepicker]="eventStartPicker" matInput
                         placeholder="{{'dynamicContent.offer.expirationDate' | translate}}">
                  <mat-datepicker-toggle [for]="eventStartPicker" matPrefix></mat-datepicker-toggle>
                  <mat-datepicker #eventStartPicker></mat-datepicker>
                </mat-form-field>
              </mat-card-content>
              <h3>{{ 'dynamicContent.offer.redeemText' | translate }}</h3>
              <editor (changeContent)="onEditorChange($event, 'redeemText')" [content]="dynamicContent.content.redeemText"
                                *ngIf="dynamicContent.lang === lang && !dynamicContent.disableMasterLanguage"></editor>
              <editor (changeContent)="onEditorChange($event, 'redeemText', lang)"
                                *ngIf="dynamicContent.lang !== lang && translationEntries[lang].content && selectedLanguage === lang"
                                [content]="translationEntries[lang].content.redeemText"></editor>
            </mat-card>
          </ng-container>
          <ng-container *ngIf="type === 'information' || type === 'event' || type === 'restaurant' || type === 'screensaver'">
            <mat-card appearance="outlined" class="offer">
              <ng-container *ngTemplateOutlet="bookableContent; context:{ lang }"></ng-container>
            </mat-card>
          </ng-container>
        </ng-container>
        <publishing *ngIf="dynamicContent.lang === lang" [dynamicContent]="dynamicContent"></publishing>
      </ng-container>

      <mat-card appearance="outlined" *ngIf="type === 'category'">
        <div class="title-container">
          <div class="title-field">
            <mat-form-field>
              <input *ngIf="dynamicContent.lang === lang" [(ngModel)]="dynamicContent.title" matInput
                     placeholder="{{'general.title' | translate}}" required #titleInput>
              <input *ngIf="dynamicContent.lang !== lang" [(ngModel)]="translationEntries[lang].title" matInput
                     placeholder="{{'general.title' | translate}}" required #titleInput>
            </mat-form-field>
            <mat-icon [matTooltip]="'dynamicContent.translateFromMain' | translate" *ngIf="dynamicContent.lang !== lang"
                      (click)="translateTitleFromMainLanguage(lang)">translate
            </mat-icon>
          </div>
        </div>
      </mat-card>

      <div class="button-right-container">
        <button (click)="save()" class="ibexfusion-raised-button" mat-button>{{ 'general.save' | translate }}</button>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>

<div *ngIf="isLoading || isTranslating" class="spinner-container">
  <mat-spinner></mat-spinner>
</div>
